import { useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router';
import { Brand } from '@/design-system/components/brand';
import { Button } from '@/design-system/components/button';
import { Spinner } from '@/design-system/components/spinner';
import { logout } from '@/lib/session';

export function Splash() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-canvas">
      <Brand />
      <Spinner className="text-fg-subtle" />
    </div>
  );
}

function Centered({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-canvas px-6 text-center">
      <Brand />
      <h1 className="mt-10 text-[24px] font-semibold tracking-[-0.02em]">{title}</h1>
      <p className="mt-2 max-w-md text-[14px] text-fg-muted">{description}</p>
      <div className="mt-8 flex gap-2">{children}</div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <Centered
      title="Página não encontrada"
      description="O endereço pode estar errado, ou o item foi removido ou não está disponível para você."
    >
      <Button asChild variant="primary">
        <Link to="/">Ir para a Home</Link>
      </Button>
    </Centered>
  );
}

export function NoOrganizationPage() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return (
    <Centered
      title="Sem acesso a um estúdio"
      description="Seu acesso foi desativado ou removido. Peça um novo convite a quem administra o estúdio."
    >
      <Button
        onClick={async () => {
          await logout().catch(() => {});
          qc.clear();
          navigate('/login', { replace: true });
        }}
      >
        Sair
      </Button>
    </Centered>
  );
}

/** Usuário do cliente logado antes do portal existir (Fase 13). */
